import React from "react";
import { APPS } from "../../lib/constants";
import { AppIcon } from "../../components/device/AppIcon";
import { Wallpaper } from "../../components/device/Wallpaper";


export const FolderApp: React.FC = ({appId}) => {
  const app = APPS.find((i)=>i.id=== appId);
  const childrenApps = app?.children || [];
  
  return (
    <div className="relative h-full w-full flex flex-col">
      <Wallpaper />
      <div className="p-8">     
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-8">
          {APPS.filter((i)=>childrenApps.includes(i.id)).map((app, index) => (
            <AppIcon key={app.id} app={app} index={index} />
          ))}
        </div>
      </div>
    </div>

  );
};

export default FolderApp;